export class NotImplementedError extends Error {
	constructor() {
		super();
		this.name = "Not Implemented Error";
		this.message= "This method has been has not been implemented. It may have been inherited from a base class which has no implementation."
	}
}